import React, { useEffect, useState } from 'react'
import mobiscroll from '@mobiscroll/react'
import * as m5 from '@mobiscroll/react5';
import { auth } from './index'
import App from './App'
import { configCols, configMultiSync, configPrice, CONFIG_REVENUE } from './components/Config'

import { version } from '../package.json'
import ErrorBoundary from './ErrorBoundary';

const Privacy = () => {
    return (
        <>
            <div className="card m-4">
                <div className="card-body">
                    <p class="h1">股票記帳本，隱私權政策</p>
                    <hr />
                    <h3 id="一、隱私權保護政策的適用範圍">一、隱私權保護政策的適用範圍</h3>
                    <p>隱私權保護政策內容，包括本APP如何處理在您使用服務時收集到的個人識別資料。</p>
                    <h3 id="二、個人資料的蒐集、處理及利用方式">二、個人資料的蒐集、處理及利用方式</h3>
                    <p>本APP所記錄相關資料只使用於APP內之功能並無用於其他用途。</p>
                    <h3 id="三、資料之保護">三、資料之保護</h3>
                    <p>本APP紀錄及傳輸過程相關資訊均有安全防護作為資料您個人資料安全保護</p>
                    <h3 id="四、網站對外的相關連結">四、網站對外的相關連結</h3>
                    <p>本APP如提供其他網站的連結，該連結網站不適用本APP的隱私權保護政策。</p>
                    <h3 id="五、與第三方人共用個人資料之政策">五、與第三方人共用個人資料之政策</h3>
                    <p>本APP絕不會提供、交換、出租或出售任何您的個人資料給其他個人或團體。但是，在以下特殊狀況下，不限於上述但書中：</p>
                    <ul>
                        <li><p>經由您同意。</p>
                        </li>
                        <li><p>法律明文規定。</p>
                        </li>
                        <li><p>當您違反服務條款或可能損害或妨礙APP與其他使用者權益或導致任何人遭受損害時，經APP管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。</p>
                        </li>
                        <li><p>司法單位因公眾安全，要求本APP公開特定個人資料時，本APP將視司法單位適法性及是否遵照法定之程序，以及考量對本所有使用者安全，採行可能必要的配合措施。</p>
                        </li>
                    </ul>
                    <h3 id="六、隱私權保護政策之修正">六、隱私權保護政策之修正</h3>
                    <p>本APP隱私權保護政策將因應需求隨時進行修正，以落實保障您的隱私權安全的立意。當本隱私權保護政策修改時，將於網站中公告。</p>
                    <div className="w-100 text-muted text-right">© 2021 LTStudio</div>
                </div>

            </div>

        </>
    )
}

const defTheme = 'light'
const initTheme = window.Stockbook
    && window.Stockbook.getTheme ? window.Stockbook.getTheme() : defTheme
const initCols = localStorage.getItem(configCols) ? localStorage.getItem(configCols) : 'def'
const initRevenue = localStorage.getItem(CONFIG_REVENUE) ? localStorage.getItem(CONFIG_REVENUE) : 'def'
const initPrice = localStorage.getItem(configPrice) ? localStorage.getItem(configPrice) : 'buyin'
const initMultiSync = localStorage.getItem(configMultiSync) === 'true' ? true : false
const USER_INFO = "USER_INFO"
const initUserInfo = localStorage.getItem(USER_INFO) ? JSON.parse(localStorage.getItem(USER_INFO)) : null
const VIP = "VIP"
const initVIP = localStorage.getItem(VIP) ? localStorage.getItem(VIP) : null


const appInitState = {
    theme: initTheme,
    cols: initCols,
    price: initPrice,
    apiCalling: false,
    multiSync: initMultiSync,
    userInfo: initUserInfo,
    vip: initVIP,
    revenue: initRevenue
}

export const AppContext = React.createContext(appInitState)

const appContextReducer = (state, action) => {
    switch (action.type) {
        case "TOGGLE_DARK_MODE":
            const newTheme = state.theme === 'dark' ? 'light' : 'dark';
            return { ...state, theme: newTheme }
        case "SET_API_CALLING":
            return { ...state, apiCalling: action.isCalling }
        case "SET_CONFIG_COLS":
            return { ...state, cols: action.cols }
        case "SET_CONFIG_PRICE":
            return { ...state, price: action.price }
        case "SET_CONFIG_REVENUE":
            return { ...state, revenue: action.revenue }
        case "SET_CONFIG_MULTI_SYNC":
            return { ...state, multiSync: action.multiSync }
        //case "SET_USER_INFO":
        //存入localStorage
        //localStorage.setItem(USER_INFO, JSON.stringify(action.userInfo))
        //return { ...state, userInfo: action.userInfo }
        case "SET_VIP":
            localStorage.setItem(VIP, action.vip)
            return { ...state, vip: action.vip }
        default:
            return state
    }
}

const Launcher = () => {
    const [appContext, dispatchAppContext] = React.useReducer(appContextReducer, appInitState)
    const [initUser, setInitUser] = useState(null)
    const [loading, setLoading] = useState(true)
    const [authFail, setAuthFail] = useState(false)

    useEffect(() => {
        //設定mobiscroll
        m5.setOptions({
            lang: 'zh',
            theme: 'ios',
            themeVariant: appContext.theme
        })

        mobiscroll.settings = {
            lang: 'zh',
            theme: 'ios',
            themeVariant: appContext.theme
        }
    }, [appContext])

    useEffect(() => {
        const user = auth.currentUser
        if (user) {
            setInitUser(user)
            setTimeout(() => {
                setLoading(false)
            }, 588)
        } else {
            const protect = setTimeout(() => {
                setAuthFail(true)
            }, 8888)
            auth.onAuthStateChanged(function (user) {
                clearTimeout(protect)
                if (user) {
                    const u = {
                        id: user.uid,
                        name: user.displayName,
                        email: user.email,
                        photoUrl: user.photoURL,
                        isAnonymous: user.isAnonymous,
                    }
                    setInitUser(u)
                } else {
                    window.location.hash = '';
                    setInitUser(null)
                }
                setTimeout(() => {
                    setLoading(false)
                }, 588)
            })
        }

    }, [])

    const restart = () => {
        setInitUser(null)
        setLoading(false)
    }

    if (window.location.pathname === '/privacy') {
        return <Privacy />
    } else if (window.Stockbook || window.location.host === 'localhost:3000') {
        let bg = 'bg-white'
        let txt = 'text-dark'
        if (appContext.theme === 'dark') {
            bg = 'bg-dark'
            txt = 'text-white'
        }
        return (
            <>
                {
                    loading ?
                        <>
                            <div style={{ position: 'absolute', top: 0, bottom: 0 }}>
                                <div className={'d-flex justify-content-center align-items-center ' + bg} style={{ height: '100vh', width: '100vw' }}>
                                    <div>
                                        <img src="/logo512.png" style={{ height: 192, width: 192 }} alt="logo" /><br />
                                        {
                                            authFail &&
                                            <>
                                                <span className="align-middle">無法正常使用？</span>
                                                <button className="btn btn-sm btn-outline-secondary" onClick={restart}>重新開始</button>
                                            </>
                                        }
                                    </div>
                                </div>

                            </div>
                            <div className={'fixed-bottom p-4 text-center ' + txt}>{version}</div>
                        </> :
                        <AppContext.Provider
                            value={{
                                appContext,
                                dispatchAppContext
                            }}>
                            <ErrorBoundary>
                                <App user={initUser} />
                            </ErrorBoundary>
                        </AppContext.Provider>
                }
            </>
        )
    } else {
        return (
            <div className="container text-center">
                <div className="h3 mt-4">請下載App使用本網站</div>
                <a rel="noreferrer" href="https://play.google.com/store/apps/details?id=com.sjlan.stockbook" target="_blank">
                    <img className="w-100" style={{ maxWidth: 300 }} src="/img/google-play-badge.png" alt="下載App" />
                </a>
                <div className="w-100 text-muted">© 2021 LTStudio</div>
            </div>

        )
    }

}

export default Launcher